import './App.css';
import List from './List';

function App() {
  const handleVideoEnd = (event) => {
    // Pause the video and freeze on the last frame
    event.target.pause();
  };

  return (
    <div className="App">
      <header className="App-header">
        {/* Video Section */}
        <video
          src="Logray Ultimate Logo.mp4"
          autoPlay
          muted
          onEnded={handleVideoEnd}
          style={{ width: '40%', height: 'auto' }}
        ></video>

        {/* Text Content */}
        <p className="small-text">Version 1.2.2</p>
        <br></br>
        <p className="smaller-text">I used to make games on Scratch, but after the moderators started taking down my projects for political reasons,<br></br>I took my business elsewhere and transferred all of my projects to this site.</p>
       <br></br>

      </header>
      <List />
    </div>
  );
}

export default App;
